import type { QueryClient } from "@tanstack/react-query";
import type { LaunchEditSearch } from "@/lib/search-params";
import { trpc } from "@/lib/trpc";

// The loader only needs who is looking, and the Launch route guard has already
// put that in the cache, so switching between Create and Edit waits on no
// request. Everything the ladder shows is a TanStack Query the page owns, keyed
// by the URL, so moving along it never waits on a route loader either.
export async function loadLaunchEditData({ context }: { context: { queryClient: QueryClient } }) {
  const viewer = await context.queryClient.ensureQueryData(trpc.organization.viewer.queryOptions());
  return { viewer };
}

export type LaunchEditLoaderData = Awaited<ReturnType<typeof loadLaunchEditData>>;

export interface LaunchEditRouteHooks {
  useLoaderData: () => LaunchEditLoaderData;
  useParams: () => { orgSlug: string };
  useSearch: () => LaunchEditSearch;
}
